import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlane,
  faHotel,
  faMap,
  faCompass,
} from '@fortawesome/free-solid-svg-icons';

export default function ChatbotBadges(props) {
  return (
    <div
      className={`tw-mt-1 tw-mx-1 md:tw-mt-0 md:tw-mx-0 tw-row-span-1 tw-col-span-1 md:tw-col-span-3 lg:tw-col-span-1`}
    >
      <div className="tw-grid tw-grid-cols-2 tw-gap-1 md:tw-gap-4 tw-h-full">
        {[
          {
            label: 'Flights',
            icon: faPlane,
            message: `Flights to ${props.locationString}`,
          },
          {
            label: 'Activities',
            icon: faCompass,
            message: `Things to do in ${props.locationString}`,
          },
          {
            label: 'Itineraries',
            icon: faMap,
            message: `${props.locationString} itinerary`,
          },
          {
            label: 'Hotels',
            icon: faHotel,
            message: `Hotels in ${props.locationString}`,
          },
        ].map(item => {
          return (
            <div
              key={item.label}
              className="tw-bg-white tw-border-gray-200 tw-bg-clip-padding tw-backdrop-filter tw-backdrop-blur-md tw-bg-opacity-25 hover:tw-bg-opacity-50 tw-border-2  tw-rounded-xl tw-p-4 cpointer"
              role="button"
              onClick={() => props.setChatMessage(item.message)}
              tabIndex={0}
            >
              <div className="tw-text-gray-200 text-center">
                <FontAwesomeIcon icon={item.icon} className="tw-h-20 tw-w-20" />
                <div className="tw-text-xl tw-font-semibold">{item.label}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
